// extracted by mini-css-extract-plugin
export var emptyListInfo = "list-module--empty-list-info--8ptNy";
export var list = "list-module--list--f9imc";